"use client";
import Link from 'next/link';
import { useAuth } from '@/context/auth-context';
import { SignIn } from '@clerk/nextjs';

export default function LoginContent() {
  const { user } = useAuth();
  const canSelectRole = user?.role === 'admin' || user?.role === 'staff';

  return (
    <div className="min-h-[80vh] w-full flex">
      <div className="relative flex-1 flex items-center justify-center overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-cyan-500" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.18),transparent_70%)]" />
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-40 -left-20 w-[34rem] h-[34rem] rounded-full bg-white/10 blur-3xl" />

        {/* Content wrapper ensures card stays inside gradient */}
        <div className="relative z-10 flex flex-col md:flex-row items-stretch gap-16 w-full max-w-6xl px-6 py-20">
          <div className="flex-1 flex flex-col justify-center text-white max-w-lg">
            <h1 className="text-[clamp(1.8rem,3.2vw,2.4rem)] font-semibold tracking-tight leading-tight mb-6">Student Sign In</h1>
            <p className="text-sm/6 text-white/90 mb-8">Log in to request and manage clinical rotations, track required documents, preview evaluation feedback, and explore optional research add‑ons.</p>
            <ul className="space-y-3 text-sm/6">
              <li className="flex gap-2"><span className="text-white/70">•</span>Rotation scheduling & status</li>
              <li className="flex gap-2"><span className="text-white/70">•</span>Document & compliance tracking</li>
              <li className="flex gap-2"><span className="text-white/70">•</span>Progress feedback snapshots</li>
            </ul>
            {canSelectRole && (
              <div className="mt-10 text-[10px] uppercase tracking-wide text-white/50">
                Switch role? <Link href="/auth/role-login" className="underline">Role selector</Link>
              </div>
            )}
          </div>
          <div className="w-full max-w-sm self-center">
            <div className="mb-8 md:hidden text-center text-white/90">
              <h2 className="text-2xl font-semibold tracking-tight mb-2">Student Login</h2>
              <p className="text-xs">Manage rotations & documents</p>
            </div>
            <div className="p-2 md:p-0">
             <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up"/>
            </div>
            {/* Removed outdated registration placeholder text */}
          </div>
        </div>
      </div>
    </div>
  );
}
